// every other node should insert comma and space, and the last node should
// have " and " instead of comma.
export const joinWithPunctuation = <T>(items: T[]): (T | string)[] => {
  if (items.length <= 1) return items;

  const lastItem = items.pop() as T;
  const joinedItems: (T | string)[] = [];

  for (let i = 0; i < items.length; i++) {
    joinedItems.push(items[i]);
    if (i < items.length - 1) {
      joinedItems.push(', ');
    }
  }

  return joinedItems.concat([' and ' as T, lastItem]);
};
